import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-settings-form',
  templateUrl: './settings-form.component.html',
  standalone: false
})
export class SettingsFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
